import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setErrorMessage("Token inválido o faltante.");
    }
  }, [token]);

  useEffect(() => {
    if (errorMessage || successMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
        setSuccessMessage("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [errorMessage, successMessage]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validatePasswords(newPassword, confirmPassword)) {
      setErrorMessage("Passwords must match and meet requirements.");
      return;
    }

    try {
      const response = await fetch("https://z3tr309yf9.execute-api.us-east-1.amazonaws.com/change-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          token: token,
          new_password: newPassword,
          confirm_password: confirmPassword
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to change password.");
      }

      setSuccessMessage("Password changed successfully.");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
      console.error("Error:", error.message);
    }
  };

  const validatePasswords = (password, confirmPassword) => {
    const isValid = password.length >= 8 && password === confirmPassword;
    return isValid;
  };

  return (
    <div className="reset-password-container mx-auto w-[90%] max-w-md mt-[10vh] p-6 bg-white rounded-xl shadow-lg border border-gray-100">
      <h1 className="text-2xl font-bold text-gray-800 text-center">Cambiar contraseña</h1>
      <p className="mt-2 text-sm text-gray-600 text-center">
        Recuerdas tu contraseña?{" "}
        <a href="/" className=" hover:underline" style={{color: "#70A771"}}>
          Ingresa aquí
        </a>
      </p>
      <form className="mt-5" onSubmit={handleSubmit}>
        <div className="grid gap-y-4">
          <div>
            <label
              htmlFor="new-password"
              className="block text-sm font-bold ml-1 mb-2"
            >
              Nueva contraseña
            </label>
            <input
              id="new-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="block w-full px-4 py-3 text-sm border rounded-md focus:ring-blue-500 focus:border-blue-500"
              placeholder="Ingrese una nueva contraseña"
              required
            />
          </div>
          <div>
            <label
              htmlFor="confirm-password"
              className="block text-sm font-bold ml-1 mb-2"
            >
              Confirmar contraseña
            </label>
            <input
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="block w-full px-4 py-3 text-sm border rounded-md focus:ring-blue-500 focus:border-blue-500"
              placeholder="Confirme la nueva contraseña"
              required
            />
          </div>
          {errorMessage && (
            <p className="text-xs text-red-600 mt-2">{errorMessage}</p>
          )}
          {successMessage && (
            <p className="text-xs text-green-600 mt-2">{successMessage}</p>
          )}
          <button
            type="submit"
            className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-bold text-white transition-all text-sm"
            style={{
              backgroundColor: "#A4D6A0",
              color: "#000",
              fontWeight: 500,
            }}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor = "#70A771")
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = "#A4D6A0")
            }
          >
            Cambiar contraseña
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
